import { FONT_STACKS, PRESENTATION_DEFAULTS } from "@/shared/config/constants";
import type { ConfiguratorConfig } from "@/configurator/domain/models/types";

/** Whether the widget paints its own frame, or blends into the host page. */
export function resolveChrome(config: ConfiguratorConfig): boolean {
  return config.presentation?.chrome ?? PRESENTATION_DEFAULTS.chrome;
}

/**
 * Configs are plain JSON (hand-written today, admin-generated later), so an
 * unknown font token can reach us at runtime without TypeScript noticing.
 */
export function resolveFontFamily(config: ConfiguratorConfig): string {
  const token = config.presentation?.font;
  if (token && !(token in FONT_STACKS)) {
    console.warn(
      `[configurator] Unknown font "${token}", falling back to "${PRESENTATION_DEFAULTS.font}". Known fonts: ${Object.keys(FONT_STACKS).join(", ")}.`,
    );
  }
  return (
    FONT_STACKS[token ?? PRESENTATION_DEFAULTS.font] ?? FONT_STACKS.poppins
  );
}
